import type { FC } from 'react';
import { Fragment } from 'react';

import { Paper, Title, Wrapper } from 'components/UI/Paper';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { title } from '../const';
import DevicePermission from './DevicePermission';
import JoinButton from './JoinButton';

const ControlPanel: FC = () => {
    const { isDesktop } = useDeviceWidth();
    const WrapperComponent = isDesktop ? Wrapper : Fragment;
    const PaperComponent = isDesktop ? Paper : Fragment;

    return (
        <WrapperComponent>
            <PaperComponent>
                {isDesktop ? <Title>{title}</Title> : null}
                <DevicePermission />
                <JoinButton />
            </PaperComponent>
        </WrapperComponent>
    );
};

export default ControlPanel;
